export * as badges from '@wix/auto_sdk_badges_badges/meta';
export * as badgesV2 from '@wix/auto_sdk_badges_badges-v-2/meta';
